import { render, staticRenderFns } from "./tousujianyi.vue?vue&type=template&id=f5866c2c&scoped=true&"
import script from "./tousujianyi.vue?vue&type=script&lang=js&"
export * from "./tousujianyi.vue?vue&type=script&lang=js&"
import style0 from "./tousujianyi.vue?vue&type=style&index=0&id=f5866c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5866c2c",
  null
  
)

export default component.exports